import Reporter, { ERROR_LEVEL, WARN_LEVEL, INFO_LEVEL } from './Reporter'

const CONFIGS = [ERROR_LEVEL, WARN_LEVEL, INFO_LEVEL]

function init(
  level,
  config,
  /* istanbul ignore next */
  initFn = () => {},
  /* istanbul ignore next */
  captureException = () => {}
) {
  const captureExceptionType = typeof captureException
  if (!CONFIGS.includes(level)) {
    console.error(
      'Reporter: bad configurartion: Invalid config ',
      level,
      '. Valid values:',
      CONFIGS
    )
  } else if (typeof initFn !== 'function') {
    console.error(
      'Reporter: bad configurartion: Invalid initFn function: ',
      typeof captureMessage
    )
  } else if (
    !(captureExceptionType === 'string' || captureExceptionType === 'function')
  ) {
    console.error(
      'Reporter: bad configurartion: Invalid captureExceptionType value (function or string)'
    )
  } else if (window.reporterInstance === undefined) {
    window.reporterInstance = new Reporter(
      level,
      config,
      initFn,
      captureException
    )
  }
  return window.reporterInstance
}

export { ERROR_LEVEL, WARN_LEVEL, INFO_LEVEL }

export default init
